
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.2085 1.4585V11.9585C11.2085 12.3335 10.8335 12.7085 10.4585 12.7085H6.7085H2.9585C2.5835 12.7085 2.2085 12.3335 2.2085 11.9585V1.4585","stroke":"#7D919B","stroke-width":"1.41667","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M0.708496 1.4585H12.7085","stroke":"#7D919B","stroke-width":"1.41667","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M5.2085 0.708496H8.2085M5.2085 4.4585V9.7085M8.2085 4.4585V9.7085","stroke":"#7D919B","stroke-width":"1.41667","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    